<template>
  <div class="overflow-y-scroll">
    <section>
      <fieldset
        class="form-field flex-row"
        v-for="(certification, index) in editCertifications"
        :key="index"
      >
        <div class="form-inline">
          <legend>
            Certification #{{ index }}:
            <a
              href="javascript:void(0)"
              class="input-prepend-btn"
              @click="addCertification(index)"
            >
              <i class="material-icons-outlined align-middle">add</i>
            </a>
            <a
              href="javascript:void(0)"
              class="input-apend-btn"
              @click="deleteCertification(index)"
            >
              <i class="material-icons-outlined align-middle">delete</i>
            </a>
          </legend>
        </div>
        <div class="form-inline certi">
          <label :for="`description-${index}`">Description:</label>
          <div class="input-group">
            <model-select
              :options="suggestions"
              v-model="editCertifications[index].description"
            ></model-select>
          </div>
        </div>
        <div class="form-inline" v-if="editCertifications[index].image_url">
          <label :for="`image-${index}`">Image:</label>
          <div class="input-group up-cret-img">
            <img :src="`${editCertifications[index].image_url}`" />
          </div>
        </div>
      </fieldset>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit Certifications
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: ["propsData", "certificationSuggestions"],
  watch: {
    propsData: function () {
      this.initData();
    },
    editCertifications: {
      handler() {
        let changed = false;
        const newArray = this.editCertifications.slice();
        newArray.forEach((item) => {
          if (item.description) {
            const suggestCer = this.certificationSuggestions.find(
              (cer) => cer.description === item.description
            );
            if (
              suggestCer &&
              (item.image !== suggestCer.fileName ||
                item.image_url !== suggestCer.url ||
                item.link !== suggestCer.link)
            ) {
              item.image = suggestCer.fileName;
              item.image_url = suggestCer.url;
              item.link = suggestCer.link;
              changed = true;
            }
          }
        });
        if (changed) {
          this.editCertifications = newArray;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      editCertifications: null,
      suggestions: [],
      focusedIndex: null,
    };
  },
  components: {
    ModelSelect,
  },
  created: function () {
    this.initData();
  },
  methods: {
    addCertification: function (index) {
      this.editCertifications.splice(index + 1, 0, {});
    },
    deleteCertification: function (index) {
      this.editCertifications.splice(index, 1);
      if (this.editCertifications.length == 0) {
        this.editCertifications.push({});
      }
    },
    initData: function () {
      if (this.propsData) {
        const propsData = JSON.parse(JSON.stringify(this.propsData));
        if (propsData && propsData.length > 0) {
          this.editCertifications = propsData;
        } else {
          this.editCertifications = [{}];
        }
      } else {
        this.editCertifications = [{}];
      }
      if (this.certificationSuggestions) {
        this.suggestions = this.certificationSuggestions.map((item) => ({
          text: item.description ? item.description : "",
          value: item.description ? item.description : "",
        }));
      }
    },
    onButtonClick: function () {
      const data = [];
      this.editCertifications.forEach((item) => {
        if (item.file || item.image || item.image_url || item.description) {
          data.push(item);
        }
      });
      this.$emit("onButtonClick", data);
    },
    onImageChange: function (index, event) {
      const file = event.target.files[0];
      if (!file || !file.type.match("image.*")) {
        return;
      }
      this.editCertifications[index].fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (arg) => {
        this.editCertifications[index].file = file;
        this.editCertifications[index].fileData = arg.target.result;
        this.editCertifications.splice(0, 0);
      };
    },
  },
};
</script>

<style scoped>
.autosuggest__results {
  margin-left: 30px !important;
}
</style>
